import request from "@/request";
import { Message, MessageSender } from "../store/types";
export interface HistoryResponse {
  hasMore: boolean;
  nextCursor: string;
  records: Message[];
}

export enum ConversationStatus {
  LineUp = 2,
  Active = 3,
}
export interface ActiveConversation {
  conversationId: string;
  hasActiveConversation: boolean;
  issueTypeId: string;
  status: ConversationStatus;
  queueDesc: string;
}

enum Score {
  ONE = 1,
  TWO = 2,
  THREE = 3,
  FOUR = 4,
  FIVE = 5,
}
interface RecordType {
  content: string;
  conversationId: string;
  resolved: boolean;
  satisfaction: Score;
}

const filterSameData = (records: Message[]) => {
  const map = new Map();
  const newList: Message[] = [];
  records.forEach((item) => {
    if (item.senderType === MessageSender.USER) {
      // 如果是用户消息，不允许clientId相同
      if (!map.get(item.clientId)) {
        newList.push(item);
        map.set(item.clientId, true);
      }
    } else {
      if (!map.get(item.id) && !map.get(item.clientId)) {
        newList.push(item);
        map.set(item.id, true);
        map.set(item.clientId, true);
      }
    }
  });
  return newList;
};

/**
 * 获取历史记录
 * @param param0
 * @returns
 */
export const getHistory = async ({
  cursor = "",
  limit = 20,
}: {
  cursor: string;
  limit?: number;
}) => {
  const result = await request.post<HistoryResponse>(`/cus/message/page`, {
    cursor,
    limit,
  });

  return {
    ...result,
    ...filterSameData(result.records.reverse()),
  };
};

/**
 * 撤回
 * @param id 消息ID
 * @returns
 */
export const recall = async (id: string) => {
  return request.post<HistoryResponse>(`/cus/message/recall`, {
    id,
  });
};

/**
 * 标记已读
 * @param ids
 */
export const markAsRead = async (ids: string[]) => {
  await request.post<HistoryResponse>(`/cus/message/maskAsRead`, {
    ids,
  });
};

/**
 * 获取当前会话类型
 * @returns ActiveConversation
 */
export const hasActiveConversation = async () => {
  return request.get<ActiveConversation>(
    `/cus/conversation/hasActiveConversation`,
  );
};

/**
 * 取消排队
 * @returns
 */
export const cancelQueue = () => {
  return request.post<boolean>(`/cus/conversation/cancelQueue`);
};

/**
 * 结束会话
 * @returns
 */
export const closeConversation = () => {
  return request.post<boolean>(`/cus/conversation/closeConversation`);
};

export const addRecord = (data: RecordType) => {
  return request.post<boolean>(`/cus/survey/addRecord`, { ...data });
};

/**
 * 判断是否发送过满意度
 * @param id
 * @returns
 */
export const reportPush = (id: string) => {
  return request.post<boolean>(`/cus/survey/reportPush`, { id });
};

/**
 * IM排班配置管理
 * @returns
 */
export const dutyRosterSave = () => {
  return request.get<{
    content: string;
    online: boolean;
  }>(`/cus/dutyRoster/show`);
};
